"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var cor_entity_1 = require("./entities/cor.entity");
Object.defineProperty(exports, "Cor", { enumerable: true, get: function () { return cor_entity_1.Cor; } });
var especie_veiculo_entity_1 = require("./entities/especie-veiculo.entity");
Object.defineProperty(exports, "EspecieVeiculo", { enumerable: true, get: function () { return especie_veiculo_entity_1.EspecieVeiculo; } });
var marca_modelo_entity_1 = require("./entities/marca-modelo.entity");
Object.defineProperty(exports, "MarcaModelo", { enumerable: true, get: function () { return marca_modelo_entity_1.MarcaModelo; } });
var tipo_veiculo_entity_1 = require("./entities/tipo-veiculo.entity");
Object.defineProperty(exports, "TipoVeiculo", { enumerable: true, get: function () { return tipo_veiculo_entity_1.TipoVeiculo; } });
var veiculo_entity_1 = require("./entities/veiculo.entity");
Object.defineProperty(exports, "Veiculo", { enumerable: true, get: function () { return veiculo_entity_1.Veiculo; } });
